import { render, staticRenderFns } from "./ModelEditView.vue?vue&type=template&id=af13f0d8"
import script from "./ModelEditView.vue?vue&type=script&lang=js"
export * from "./ModelEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports